export const PermitTranslations = {
	page_title: "page-title",
	email: "email", //Email
	password: "password", //Password
	phoneNumber: "phone-number", //Phone Number
	cancel: "cancel", //Cancel
	delete: "delete",
	edit: "edit", //Edit
	back: "back", //Back
	next: "next", //Next
	sign_in: "sign-in", //Sign in
	sign_up: "sign-up", //Sign up
	send: "send", //Send
	log_out: "log-out", //Log out
	select_an_option: "select-an-option", //Log out
	given_name: "given-name", //First name
	family_mame: "family-name", //Last name
	save_changes: "save-changes", //Save changes
	accept_and_pay: "accept-and-pay", //Accept and pay
	permit_type: "permit-type", //Permit Type
	reservation_type: "reservation-type", //Type
	invoice_id: "invoice-id", //Invoice Id
	date: "date", //Date
	driver: "driver", //Driver
	residency: "residency", //Residency
	vehicles: "vehicles", //Vehicles
	start_date: "start-date", //Start date
	start_time: "start-time", //Start time
	end_date: "end-date", //End date
	end_time: "end-time", //End time
	days_of_week: "days-of-week", //Days of the week
	zone: "zone", //Zone
	welcome_back: "welcome-back",
	wallet_balance: "wallet-balance",
	permit_tariff: "permit-tariff", //Permit type
	reservation_tariff: "reservation-tariff", //Reservation type
	tariff_list_format1: "tariff-list-format1",
	tariff_list_format2: "tariff-list-format2",
	address: "address", //Address
	purpose: "purpose", //Purpose
	streets: "streets", //Streets
	meters: "meters", //Meters
	view: "view", //View
	view_all: "view-all", //View all
	apply: "apply", //Apply
	done: "done", //Done
	amount: "amount", //Amount:
	amount_plus_vat: "amount-plus-vat", //Amount:
	amount_without_bonification: "amount-without-bonification",
	fee: "fee", //Service fee:
	vat: "vat", //Vat:
	fee_plus_vat: "fee-plus-vat", //Vat:
	price: "price", //Price:
	sub_total: "sub-total", //Subtotal:
	total: "total", //Total:
	wallet: "wallet", //Wallet:
	bonification_amount: "bonification-amount",
	bonification_discount: "bonification-discount",
	bonification_surcharge: "bonification-surcharge",
	pay: "pay", //Pay {total}
	preview: "preview", //Preview
	download: "download", //Download
	upload: "upload", //Upload
	repeat: "repeat", //Repeat
	add_new: "add-new", //Add new
	change_in_progress: "change-in-progress",
	visitor_pass: "visitor-pass",//Visitor pass
	add_visitor_pass: "add-visitor-pass",//Add visitor pass
	add_visitor_pass__invalid: "add-visitor-pass--invalid",//Permit must be approved before you can add a visitor pass
	send_for_review: "send-for-review",//Send for review
	number_of_months: "number-of-months",
	number_of_months_placeholder: "number-of-months-placeholder",

	block_type: "block-type",
	block_type__on_street: "block-type--on-street",
	block_type__off_street: "block-type--off-street",
	download_reservation_signal: "download-signal",
	download_reservation_quote: "download-reservation-quote",
	download_reservation_invoice: "download-reservation-invoice",
	list_toggle__hidden: "list-toggle--hidden",
	list_toggle__visible: "list-toggle--visible",
	attachments__multiple: "attachments--multiple",
	credit_card__expiration: "credit-card--expiration",

	entity_type: "entity-type",//Belongs to
	entity_information: "entity-information",//Belongs to
	document_type: "document-type",//Document type
	expiration_date: "expiration-date",//Expiration date
	document_status: "document-status",//Status

	recurrence__recurrency: "recurrence__recurrency",//Recurrency
	recurrence__recurrency__desc: "recurrence__recurrency--desc",//Select the dates and times you want to repeat this event.
	recurrence__range: "recurrence__range",//Range
	recurrence__range__desc: "recurrence__range--desc",//Choose the period during which this visitor pass should be active.
	recurrence__repeat: "recurrence__repeat",//Repeat
	recurrence__date__start: "recurrence__date--start",//Period start date
	recurrence__date__end: "recurrence__date--end",//Period end date
	recurrence__type__none: "recurrence__type--none",//None
	recurrence__type__daily: "recurrence__type--daily",//Daily
	recurrence__type__weekly: "recurrence__type--weekly",//Weekly
	recurrence__type__monthly: "recurrence__type--monthly",//Monthly
	recurrence__type__yearly: "recurrence__type--yearly",//Yearly
	recurrence__notes: "recurrence__notes",//Recurrent permit on {days}

	entity__type__holder: "entity__type--holder",//Holder
	entity__type__permit: "entity__type--permit",//Permit
	entity__type__residency: "entity__type--residency",//Residency
	entity__type__driver: "entity__type--driver",//Driver
	entity__type__vehicle: "entity__type--vehicle",//Vehicle

	modify_address: "modify-address", //Modify address
	modify_vehicle: "modify-vehicle", //Modify vehicle

	website__application_loading: "website__application-loading", //Loading application configuration...
	website__terms_and_conditions: "website__terms-and-conditions", //By tapping "Sign up" or "Sign in" you agree to our Conditions of Use.  Learn how we process your data in our Privacy Policy and Cookies Policy.

	menu__new: "menu__new", //New
	menu__my_parking: "menu__my-parking", //My Parking
	menu__payments: "menu__payments", //Payments
	menu__vehicles: "menu__vehicles", //Vehicles
	menu__documents: "menu__documents", //Documents
	menu__invoices: "menu__invoices", //Invoices
	menu__settings: "menu__settings", //Settings

	welcome_page__title: "welcome-page__title", //Welcome to the Pittsburgh Parking Application Portal
	welcome_page__body: "welcome-page__body", //From this web portal, residents and non-residents are able to apply for, pay for, and manage their residential and non-residential parking permits without any need to come downtown or mail in documents. We still process applications via mail for residents who do not use email and at our walk-in counter.\n\nThe cost of the Residential Parking Permit is $20.00 per vehicle per program year and is not prorated for mid-year purchases. The cost to purchase an annual Visitor Parking Pass is $1.00 per address and is not prorated. There is a $2.50 processing fee for credit card purchases.\n\nPERMITS DO NOT EXPIRE ONE YEAR FROM PURCHASE DATE; EACH PERMIT AREA HAS ITS OWN EXPIRATION MONTH BY PROGRAM YEAR, NOT CALENDAR YEAR.
	welcome_page__or: "welcome-page__or", //Or
	features__portal_unavailable: "features__portal-unavailable",

	sign_in_page__forgot_password: "sign-in-page__forgot-password", //Forgot your password?

	sign_up_page__mandatory_password: "sign-up-page__mandatory-password", //Password is mandatory to create an account
	sign_up_page__already_have_account: "sign-up-page__already-have-account", //Already have an account?
	sign_up_page__log_into_account: "sign-up-page__log-into-account", //Log into Account
	sign_up_page__email_duplicated__title: "sign-up-page__email-duplicated--title", //A Blinkay account already exists with this email address.
	sign_up_page__email_duplicated__body: "sign-up-page__email-duplicated--body", //Please click "Sign in" if you remember your password, or click "Change password" if you need to reset it.
	sign_up_page__change_password: "sign-up-page__change-password", //

	forgot_password_page__forget_your_password: "forgot-password-page__forget-your-password", //Forget your password?
	forgot_password_page__instructions: "forgot-password-page__instructions", //We will email you instructions on how to create a new password
	forgot_password_page__email_sent: "forgot-password-page__email-sent", //You're almost there!
	forgot_password_page__email_sent__body: "forgot-password-page__email-sent--body", //We've sent a password-reset link to your email address. Please check your inbox and click the link to create a new password.

	new_permits_page__title: "new-permits-page__title", //Pittsburgh Parking Portal

	new_permit_page__title: "new-permit-page__title", //New permit
	new_permit_page__start_over: "new-permit-page__start-over", //Start over
	new_permit_page__permit_type__wizard: "new-permit-page__permit-type--wizard", //Permit type
	new_permit_page__permit_type__title: "new-permit-page__permit-type--title", //Permit type
	new_permit_page__permit_type__label: "new-permit-page__permit-type--label",
	new_permit_page__holder_type: "new-permit-page__holder-type", //Individual or Business
	new_permit_page__holder_type__hint: "new-permit-page__holder-type--hint", //Individual or Business
	new_permit_page__business: "new-permit-page__business", //Business data
	new_permit_page__business__hint: "new-permit-page__business--hint",
	new_permit_page__business__name: "new-permit-page__business__name",//Business Name
	new_permit_page__business__taxId: "new-permit-page__business__tax-id",
	new_permit_page__zone__wizard: "new-permit-page__zone--wizard", //Zone
	new_permit_page__zone__title: "new-permit-page__zone--title", //Zone
	new_permit_page__find_address: "new-permit-page__find-address", //Please find a valid address
	new_permit_page__find_address__missing: "new-permit-page__find-address--missing", //No valid data was found on our system for that address
	new_permit_page__find_address__missing_body: "new-permit-page__find-address--missing-body", //No valid data was found on our system for that address
	new_permit_page__find_address__invalid: "new-permit-page__find-address--invalid", //Please find a valid address
	new_permit_page__find_address__invalid_body: "new-permit-page__find-address--invalid-body", //Please find a valid address
	new_permit_page__tariff_type__wizard: "new-permit-page__tariff-type--wizard",
	new_permit_page__tariff_type__title: "new-permit-page__tariff-type--title",
	new_permit_page__tariff_type__hint: "new-permit-page__tariff-type--hint",
	new_permit_page__tariff_type__label: "new-permit-page__tariff-type--label",
	new_permit_page__tariff_type__search__label: "new-permit-page__tariff-type__search--label",
	new_permit_page__tariff_type__search__hint: "new-permit-page__tariff-type__search--hint",
	new_permit_page__residency__wizard: "new-permit-page__residency--wizard",
	new_permit_page__residency__title: "new-permit-page__residency--title",
	new_permit_page__residency__hint: "new-permit-page__residency--hint",
	new_permit_page__documentation__wizard: "new-permit-page__documentation--wizard",
	new_permit_page__documentation__title: "new-permit-page__documentation--title",
	new_permit_page__documentation__hint: "new-permit-page__documentation--hint",
	new_permit_page__driver__wizard: "new-permit-page__driver--wizard",
	new_permit_page__driver__title: "new-permit-page__driver--title",
	new_permit_page__driver__hint: "new-permit-page__driver--hint",
	new_permit_page__vehicle__wizard: "new-permit-page__vehicle--wizard",
	new_permit_page__vehicle__title: "new-permit-page__vehicle--title",
	new_permit_page__vehicle__hint: "new-permit-page__vehicle--hint",
	new_permit_page__vehicle__label: "new-permit-page__vehicle--label",
	new_permit_page__vehicle__selection_text: "new-permit-page__vehicle--selection-text",
	new_permit_page__vehicle__selection_help: "new-permit-page__vehicle--selection-help",
	new_permit_page__review_application__wizard: "new-permit-page__review-application--wizard",
	new_permit_page__review_application__title: "new-permit-page__review-application--title",
	new_permit_page__review_application__expiration: "new-permit-page__review-application--expiration",
	new_permit_page__payment_method__wizard: "new-permit-page__payment-method--wizard",
	new_permit_page__payment_method__title: "new-permit-page__payment-method--title",

	new_permit_page__send_to_evaluation__title: "new-permit-page__send-to-evaluation--title",
	new_permit_page__send_to_evaluation__label: "new-permit-page__send-to-evaluation--label",
	new_permit_page__approved__title: "new-permit-page__approved--title",
	new_permit_page__approved__label: "new-permit-page__approved--label",

	new_reservation_page__out_of_service: "new-reservation-page__out-of-service",
	new_reservation_page__purpose__wizard: "new-reservation-page__purpose--wizard",
	new_reservation_page__purpose__title: "new-reservation-page__purpose--title",
	new_reservation_page__purpose__hint: "new-reservation-page__purpose--hint",
	new_reservation_page__purpose__label: "new-reservation-page__purpose--label",
	new_reservation_page__purpose__construction: "new-reservation-page__purpose--construction",
	new_reservation_page__purpose__construction_id: "new-reservation-page__purpose--construction-id",
	new_reservation_page__purpose__construction_label: "new-reservation-page__purpose--construction-label",

	new_reservation_page__spaces__wizard: "new-reservation-page__spaces--wizard",
	new_reservation_page__spaces__title: "new-reservation-page__spaces--title",
	new_reservation_page__spaces__hint: "new-reservation-page__spaces--hint",
	new_reservation_page__spaces__label: "new-reservation-page__spaces--label",
	new_reservation_page__street_number__placeholder: "new-reservation-page__street-number--placeholder",

	new_reservation_page__meters__wizard: "new-reservation-page__meters--wizard",
	new_reservation_page__meters__title: "new-reservation-page__meters--title",
	new_reservation_page__meters__hint: "new-reservation-page__meters--hint",
	new_reservation_page__meters__label: "new-reservation-page__meters--label",

	new_reservation_page__dates__wizard: "new-reservation-page__dates--wizard",
	new_reservation_page__dates__title: "new-reservation-page__dates--title",
	new_reservation_page__dates__hint: "new-reservation-page__dates--hint",
	new_reservation_page__dates__label: "new-reservation-page__dates--label",

	new_reservation_review_application: "new-reservation-review-application",
	reservation_page__approve: "reservation-page__approve",

	permit_page__qr_code_text: "permit-page__qr-code-text",
	permit_page__renew__title: "permit-page__renew--title",
	permit_page__renew__button: "permit-page__renew--button",
	permit_page__renew_group__title: "permit-page__renew-group--title",
	permit_page__renew_group__button: "permit-page__renew-group--button",
	permit_menu__auto_renew__enable: "permit-menu__auto-renew--enable", //Enable auto-renewal
	permit_menu__auto_renew__enabled: "permit-menu__auto-renew--enabled", //This permit is set for auto-renewal
	permit_menu__auto_renew__disable: "permit-menu__auto-renew--disable", //Disable auto-renewal
	permit_menu__auto_renew__disabled: "permit-menu__auto-renew--disabled", //This permit is NOT set for auto-renewal
	permit_page__bill__title_to_pay: "permit-page__bill--title-to-pay",
	permit_page__bill__title_error: "permit-page__bill--title-error",
	permit_page__bill__button: "permit-page__bill--button",

	permit_unpark__button: "permit-unpark__button",
	permit_unpark_page__title: "permit-unpark-page__title",
	permit_unpark_page__button: "permit-unpark-page__button",
	permit_unpark_page__refunded: "permit-unpark-page__refunded",
	permit_unpark_page__remaining: "permit-unpark-page__remaining",

	summary_page__title: "summary-page__title", //My parking
	summary_page__add_new_permit: "summary-page__add-new-permit", //Add new permit
	summary_page__cancel_permit: "summary-page__cancel-permit", //Cancel permit
	summary_page__cancel_permits: "summary-page__cancel-permits", //Cancel all permits
	summary_page__cancel_reservation: "summary-page__cancel-reservation", //Cancel
	summary_page__approve_reservation: "summary-page__approve-reservation", //Approve Quote
	summary_page__quoted_reservation: "summary-page__quoted-reservation", //Quote to be approved
	summary_page__cancel_permit__alert: "summary-page__cancel-permit--alert",
	summary_page__cancel_active_permit__alert: "summary-page__cancel-active-permit--alert",
	summary_page__cancel_permits__alert: "summary-page__cancel-permits--alert", //Cancel all permits
	summary_page__cancel_reservation__alert: "summary-page__cancel-reservation--alert", //Once you cancel the permit, {total} will be refunded and placed back into your wallet. Do you want to continue?
	summary_page__cancel_active_reservation__alert: "summary-page__cancel-active-reservation--alert",
	summary_page__permits: "summary-page__permits", //Permits
	summary_page__reservations: "summary-page__reservations", //Reservations
	summary_page__archived__permits: "summary-page__archived--permits", //Archived
	summary_page__archived__reservations: "summary-page__archived--reservations", //Archived
	summary_page__no_permits: "summary-page__no-permits", //No permits found
	summary_page__no_reservations: "summary-page__no-reservations",
	summary_page__filters: "summary-page__filters", //Filters
	summary_page__filters__status_label: "summary-page__filters__status-label", //Status
	summary_page__filters__status_title: "summary-page__filters__status-title", //Filter by status
	summary_page__filters__plate_label: "summary-page__filters__plate-label", //Plate
	summary_page__filters__plate_title: "summary-page__filters__plate-title", //Filter by plate
	summary_page__filters__tariff_label: "summary-page__filters__tariff-label", //Permit type
	summary_page__filters__tariff_title: "summary-page__filters__tariff-title", //Filter by permit type
	summary_page__filters__tariff_placeholder: "summary-page__filters__tariff-placeholder", //Please select a permit type

	payments_page__title: "payments-page__title", //Payments
	payments_page__no_card: "payments-page__no-card", //No credit card on file, please add one
	payments_page__add_new_card: "payments-page__add-new-card", //Add a new card
	payments_page__remove_card: "payments-page__remove-card", //Remove card
	payments_page__change_card: "payments-page__change-card", //Change card
	payments_page__remove_card__remove: "payments-page__remove-card--remove",

	payments_page__popup_error__title: "payments-page__popup-error--title", //Unable to open a new window for the payment authorization process
	payments_page__popup_error__description: "payments-page__popup-error--description", //This may be due to pop-up blocking. Please check your browser settings or extensions to ensure pop-ups are allowed for this site and try again.
	payments_page__popup_error__footer: "payments-page__popup-error--footer", //Thank you!
	payments_page__authorization_error__title: "payments-page__authorization-error--title", //We're sorry: we encountered an issue while processing your payment authorization
	payments_page__authorization_error__description: "payments-page__authorization-error--description", //Our team has been notified, and we recommend checking your payment details or trying again shortly. If the issue persists, please contact our support team for assistance.
	payments_page__authorization_error__footer: "payments-page__authorization-error--footer", //Thank you for your patience!
	payments_page__close_window__title: "payments-page__close-window--title", //Unable to open a new window for the payment authorization process
	payments_page__close_window__description: "payments-page__close-window--description", //This may be due to pop-up blocking. Please check your browser settings or extensions to ensure pop-ups are allowed for this site and try again.
	payments_page__close_window__footer: "payments-page__close-window--footer", //Thank you!

	payment_page__payment_method: "payment-page__payment-method",
	payment_page__payment_method__select: "payment-page__payment-method--select",
	payment_page__payment_method__required: "payment-page__payment-method--required",
	payment_page__payment_method__credit_card__required: "payment-page__payment-method__credit-card--required",
	payment_page__payment_method__check_number: "payment-page__payment-method__check-number",
	payment_page__payment_method__check_number__required: "payment-page__payment-method__check-number--required",

	invoices_page__title: "invoices-page__title", //Invoices
	invoices_page__no_invoices: "invoices-page__no-invoices",

	settings_page__title: "settings-page__title", //Settings
	settings_page__change_password: "settings-page__change-password", //Change password
	settings_page__old_password: "settings-page__old-password", //Old password

	complete_profile_page__title: "complete-profile-page__title", //Complete your profile
	complete_profile_page__subtitle: "complete-profile-page__subtitle", //Please provide the following details to continue

	form_error__title: "form-error__title", //Something went wrong
	sign_in__load_failed: "sign-in__load-failed", //We couldn't load your account data. Please try again.

	create_permit__upload_files: "create-permit__upload-files",
	create_permit__create_permit: "create-permit__create-permit",
	create_permit__create_reservation: "create-permit__create-reservation",

	documents_page__title: "documents-page__title", //Documents
	documents_page__no_documents: "documents-page__no-documents",
	documents_page__filters: "documents-page__filters", //Filters
	documents_page__filters__document_type_label: "documents-page__filters__document-type-label", //Type
	documents_page__filters__document_type_title: "documents-page__filters__document-type-title", //Filter by document type
	documents_page__filters__document_type_placeholder: "documents-page__filters__document-type-placeholder", //All document types
	documents_page__filters__category_label: "documents-page__filters__category-label", //Category
	documents_page__filters__category_title: "documents-page__filters__category-title", //Filter by category
	documents_page__filters__category_placeholder: "documents-page__filters__category-placeholder", //All categories
	documents_page__filters__status_label: "documents-page__filters__status-label", //Status
	documents_page__filters__status_title: "documents-page__filters__status-title", //Filter by status

	documentation: "documentation", //Documentation
	documentation__status: "documentation__status", //Status:
	documentation__reason: "documentation__reason", //Reason:
	documentation__expires: "documentation__expires", //Expires:
	documentation__comments: "documentation__comments", //Comments:
	documentation__required: "documentation__required", //Required documentation
	documentation__additional: "documentation__additional", //Additional documentation
	documentation__update: "documentation__update", //Documentation to update
	documentation__update__action: "documentation__update--action", //Update documentation
	documentation__expired: "documentation__expired", //Expired/rejected documentation
	documentation__expired__description: "documentation__expired--description",
	documentation_page__title: "documentation-page__title", //Update documentation
	documentation__update__button: "documentation__update--button", //Update documentation
	documentation__updated: "documentation__updated", //All documents have been updated

	driver__full_name: "driver__full-name", //Driver full name
	driver__license_number: "driver__license-number", //License number

	new_driver__choose: "new-driver__choose", //Choose a driver
	new_driver__full_name: "new-driver__full-name", //Last name
	new_driver__license_number: "new_driver__license-number", //License number

	new_company__name: "new-company--name",
	new_company__tax_id: "new-company--tax-id",

	reservation_block__area: "reservation-block__area",
	reservation_block__street: "reservation-block__street",
	reservation_block__street_number: "reservation-block__street-number",
	reservation_block__space_count: "reservation-block__space-count",
	reservation_block__add_block: "reservation-block__add-block",
	reservation_block__hourly_rate: "reservation-block__hourly-rate",
	reservation_block__total: "reservation-block__total",
	reservation_meter: "reservation-meter",
	reservation_meters: "reservation-meters",
	reservation_meter__add_meter: "reservation-meter__add-meter",
	reservation__quote_text: "reservation__quote-text",
	reservation__quote__total_spaces: "reservation__quote__total-spaces",
	reservation__quote__removed_meters: "reservation__quote__removed-meters",
	reservation__quote__total_hours: "reservation__quote__total-hours",
	reservation__quote__total_amount: "reservation__quote__total-amount",
	reservation__void_payment__title: "reservation__void-payment--title",
	reservation__void_payment__total: "reservation__void-payment--total",

	residency__street_number: "residency__street-number", //Street number
	residency__street: "residency__street", //Street
	residency__unit: "residency__apt-unit", //Apartment/Unit
	residency__suffix: "residency__suffix", //Suffix
	residency__postal_code: "residency__postal-code", //Postal code
	residency__city: "residency__city", //City
	residency__state: "residency__state", //State

	new_residency__street_number: "new-residency__street-number", //Street number
	new_residency__street: "new-residency__street", //Street
	new_residency__apt_unit: "new-residency__apt-unit", //Apt/Unit (Only the number or letter, NO special characters)
	new_residency__suffix: "new-residency__suffix", //Suffix
	new_residency__postal_code: "new-residency__postal-code", //Postal code
	new_residency__city: "new-residency__city", //City
	new_residency__state: "new-residency__state", //State
	new_residency__choose: "new-residency__choose", //Choose a residency
	new_residency__zone_warning__title: "new-residency__zone-warning--title",
	new_residency__zone_warning__detail: "new-residency__zone-warning--detail",

	vehicle__plate: "vehicle__plate", //License plate
	vehicle__nickname: "vehicle__nickname", //Nickname
	vehicle__type: "vehicle__type", //Year
	vehicle__color: "vehicle__color", //Color
	vehicle__color__placeholder: "vehicle__color__placeholder", //Please select a color
	vehicle__model: "vehicle__model", //Make
	vehicle__model__placeholder: "vehicle__model__placeholder", //Please select a make
	vehicle__province: "vehicle__province", //State
	vehicle__province__placeholder: "vehicle__province__placeholder", //Please select a state

	new_vehicle__choose: "new-vehicle__choose", //Choose a vehicle
	new_vehicle__plate: "new-vehicle__plate", //License plate
	new_vehicle__nickname: "new-vehicle__nickname", //Nickname
	new_vehicle__color: "new-vehicle__color", //Color
	new_vehicle__model: "new-vehicle__model", //Make
	new_vehicle__type: "new-vehicle__type", //Year
	new_vehicle__province: "new-vehicle__province", //State
	new_vehicle__old_vehicle__label: "new-vehicle__old-vehicle--label",

	vehicles_page__title__new: "vehicles-page__title--new", //New vehicle
	vehicles_page__title__edit: "vehicles-page__title--edit", //Edit vehicle
	vehicles_page__residents: "vehicles-page__residents", //Residents
	vehicles_page__visitors: "vehicles-page__visitors", //Visitors
	vehicles_page__no_vehicles: "vehicles-page__no-vehicles", //No vehicles found
	vehicles_page__remove_vehicle: "vehicles-page--remove",

	validation__generic__required: "validation__generic--required", //The {value} is required
	validation__generic__max_size: "validation__generic--max-size", //The maximum allowed size for documents is 10 mb
	validation__number_of_month__required: "validation__number-of-month--required", //The number of months is required
	validation__vehicle_list__required: "validation__vehicle-list--required",

	validation__start_date__required: "validation__start-date--required", //The start date is required
	validation__start_time__required: "validation__start-time--required", //The start time is required
	validation__start_period__required: "validation__start-period--required", //The period start date is required
	validation__end_date__required: "validation__end-date--required", //The end date is required
	validation__end_time__required: "validation__end-time--required", //The end time is required
	validation__end_period__required: "validation__end-period--required", //The period end date is required

	validation__reservation__purpose__required: "validation__reservation__purpose--required",
	validation__reservation__purpose__construction: "validation__reservation__purpose--construction",
	validation__reservation__purpose__construction_id: "validation__reservation__purpose--construction-id",

	validation__reservation_block__street__required: "validation__reservation-block__street--required",
	validation__reservation_block__street__invalid: "validation__reservation-block__street--invalid",
	validation__reservation_block__street_number__required: "validation__reservation-block__street-number--required",
	validation__reservation_block__street_number__invalid: "validation__reservation-block__street-number--invalid",
	validation__reservation_block__space_count__required: "validation__reservation-block__space-count--required",

	validation__reservation_meter_id__required: "validation__reservation-meter-id--required",

	validation__reservation_end_date__minimum: "validation__reservation-end-date--minimum",

	validation__business__name__required: "validation__business__name--required", //The business name is required
	validation__business__tax_id__required: "validation__business__tax-id--required", //An ABN or ACN is required

	validation__residency__street_number__required: "validation__residency__street-number--required",
	validation__residency__street__required: "validation__residency__street--required",
	validation__residency__unit__required: "validation__residency__unit--required",
	validation__residency__postal_code__required: "validation__residency__postal-code--required",
	validation__residency__city__required: "validation__residency__city--required",
	validation__residency__state__required: "validation__residency__state--required",

	validation__residency__city__placeholder: "validation__residency__city--placeholder",
	validation__residency__state__placeholder: "validation__residency__state--placeholder",
	validation__residency__zone__placeholder: "validation__residency__zone--placeholder", //Please select a zone
	validation__residency__already_used: "validation__residency__already__used",

	validation__vehicle__plate__duplicated: "validation__vehicle__plate--duplicated", //
	//Same as above, but for the forms that offer the "use the existing one" button. Falls back to
	//validation__vehicle__plate--duplicated while an installation has not imported it.
	validation__vehicle__plate__duplicated__select: "validation__vehicle__plate--duplicated--select", //
	validation__vehicle__type__invalid: "validation__vehicle__type--invalid",

	validation__email__required: "validation__email--required", //Email is required
	validation__email__invalid: "validation__email--invalid", //Email is invalid
	validation__email__length: "validation__email--length",
	validation__password__required: "validation__password--required", //Password is required
	validation__password_rules: "validation__password-rules", //Password must contain:
	validation__password_rules__01_text: "validation__password-rules--01-text", //12 or more characters
	validation__password_rules__02_text: "validation__password-rules--02-text", //mixture of uppercase and lowercase
	validation__password_rules__03_text: "validation__password-rules--03-text", //letters and numbers
	validation__password_rules__04_text: "validation__password-rules--04-text", //one special character, e.g., ! @ # ?
	validation__password_rules__05_text: "validation__password-rules--05-text", //30 or fewer characters
	validation__password_rules__01_requirement: "validation__password-rules--01-requirement", //Password must be 12 or more characters
	validation__password_rules__02_requirement: "validation__password-rules--02-requirement", //Password must contain a mixture of uppercase and lowercase
	validation__password_rules__03_requirement: "validation__password-rules--03-requirement", //Password must contain letters and numbers
	validation__password_rules__04_requirement: "validation__password-rules--04-requirement", //Password must contain one special character, e.g., ! @ # ?
	validation__password_rules__05_requirement: "validation__password-rules--05-requirement", //Password must be less than 30 characters
	validation__old_password__required: "validation__old-password--required", //Old password is required
	validation__given_name__required: "validation__given-name--required", //The first name is required
	validation__family_name__required: "validation__family-name--required", //The last name is required
	validation__phone__required: "validation__phone--required", //The phone number is required
	validation__phone__invalid: "validation__phone--invalid", //Phone number is invalid

	// Language selector
	language_selector__label: "language-selector--label", //Language

	// Yes/No selector
	selector_same_vehicle__yes: "selector-same-vehicle--yes", //Yes
	selector_same_vehicle__no: "selector-same-vehicle--no", //No

	// Payment providers
	payment_provider__credit_call: "payment-provider--credit-call", //Credit call
	payment_provider__iecisa: "payment-provider--iecisa", //IECISA
	payment_provider__elavon_santander: "payment-provider--elavon-santander", //Elavon Santander
	payment_provider__stripe: "payment-provider--stripe", //Stripe
	payment_provider__moneris: "payment-provider--moneris", //Moneris
	payment_provider__transbank: "payment-provider--transbank", //Transbank
	payment_provider__payu: "payment-provider--payu", //PayU
	payment_provider__paypal: "payment-provider--paypal", //PayPal
	payment_provider__niidea: "payment-provider--niidea", //NiIdea
	payment_provider__debit_credit_card: "payment-provider--debit-credit-card", //Debit/Credit card
	payment_provider__mercadopago: "payment-provider--mercadopago", //MercadoPago
	payment_provider__windcave: "payment-provider--windcave", //Windcave

	// Not found page
	page_not_found__message: "page-not-found--message", //Oops! The page you are looking for does not exist.
	page_not_found__go_back_link: "page-not-found--go-back-link", //Go back to the home page.

	// Multiple vehicle wizard
	wizard_vehicle__add_group_label: "wizard-vehicle--add-group-label", //Add more permits
	wizard_vehicle__add_vehicle_label: "wizard-vehicle--add-vehicle-label", //Add more vehicles
	wizard_vehicle__group_count_label: "wizard-vehicle--group-count-label",
	wizard_vehicle__vehicle_count_label: "wizard-vehicle--vehicle-count-label",

	// Visitor review validations
	validation__invalid_start_time: "validation__invalid-start-time", //Invalid start time
	validation__invalid_end_time: "validation__invalid-end-time", //Invalid end time
	validation__invalid_end_date: "validation__invalid-end-date", //Invalid end date
	validation__invalid_start_date: "validation__invalid-start-date", //Invalid start date
	validation__invalid_period_end_time: "validation__invalid-period-end-time", //Invalid period end time

	// Visitor wizard errors
	error__missing_parent_permit_id: "error--missing-parent-permit-id", //Missing parent permit id
	error__missing_tariff_id: "error--missing-tariff-id", //Missing tariff id
	error__invalid_parent_permit_id: "error--invalid-parent-permit-id", //Invalid parent permit id: {value}
	error__invalid_permit_id: "error--invalid-permit-id", //Invalid permit id: {value}

	// Group errors
	error__missing_group_name: "error--missing-group-name", //Missing group name

	// Weather review
	review_weather__select_date_aria: "review-weather--select-date-aria", //Select date

	// Pittsburgh permits home
	pittsburgh__residential_permit_visitor: "pittsburgh--residential-permit-visitor", //Residential Permit & Visitor
	pittsburgh__business_permit_visitor: "pittsburgh--business-permit-visitor", //Business Permit & Visitor
	pittsburgh__nanny_permit: "pittsburgh--nanny-permit", //Nanny Permit
	pittsburgh__construction_permit: "pittsburgh--construction-permit", //Construction Permit
	pittsburgh__medical_pass: "pittsburgh--medical-pass", //Medical Pass
	pittsburgh__monthly_lot_leases: "pittsburgh--monthly-lot-leases", //Monthly Lot Leases
	pittsburgh__coming_soon: "pittsburgh--coming-soon", //Coming soon
	pittsburgh__out_of_service: "pittsburgh--out-of-service", //Out of Service

	// Coral Gables permits home
	coral_gables__residential_permit_visitor: "coral-gables--residential-permit-visitor", //Residential Permit & Visitor
	coral_gables__monthly_individual_permit: "coral-gables--monthly-individual-permit",
	coral_gables__monthly_business_permit: "coral-gables--monthly-business-permit",
	coral_gables__auto_renew__label: "coral-gables__auto-renew--label",
	coral_gables__auto_renew__wizard: "coral-gables__auto-renew--wizard",
	coral_gables__auto_renew__title: "coral-gables__auto-renew--title",
	coral_gables__auto_renew__hint: "coral-gables__auto-renew--hint",
	coral_gables__auto_renew__button__yes: "coral-gables__auto-renew__button--yes",
	coral_gables__auto_renew__button__no: "coral-gables__auto-renew__button--no",

	// Sherbrooke permits home
	sherbrooke__home__1: "sherbrooke__home--1",
	sherbrooke__home__2: "sherbrooke__home--2",
	sherbrooke__home__3: "sherbrooke__home--3",
	sherbrooke__home__button__1: "sherbrooke__home__button--1",
	sherbrooke__home__button__2: "sherbrooke__home__button--2",
	sherbrooke__yourself: "sherbrooke--yourself", //Vous-même
	sherbrooke__start: "sherbrooke--start", //Commencer
	sherbrooke__enterprise: "sherbrooke--enterprise", //Une entreprise ou un organisme

	// Gava permits home
	gava__resident_non_taxed_vehicle: "gava--resident-non-taxed-vehicle", //Resident amb vehicle que no tributa a Gavà
	gava__second_residency_worker: "gava--second-residency-worker", //2ª residencia o treballador a Gavà

	// Purpose wizard
	purpose_wizard__domi_placeholder: "purpose-wizard--domi-placeholder", //DOMI-XX-YYYY-NNNNN

	// Operation timeout
	operation_timeout__time_left: "operation-timeout--time-left" //You have {time} left to complete the operation
} as const;
